// extracted by mini-css-extract-plugin
module.exports = {"planet6":"PlanetaFooter1_planet6__1w4vG"};